import styled from 'styled-components';

export const TableContainer = styled.div`
  margin: 1rem;
`;
